import { brands } from "utils/common";
import { Fragment } from "react";
import appConfig from "config.json";

const { brands: configBrands } = appConfig;

const Decoration = ({ brand, mainClass, style, src }) => {
	return (
		<Fragment>
			{brand === brands.disneycruise && (
				<Fragment>
					<div className={`${mainClass}__light-rays`}>
						<div className={`${mainClass}__light-rays__ray-0`}></div>
						<div className={`${mainClass}__light-rays__ray-1`}></div>
						<div className={`${mainClass}__light-rays__ray-2`}></div>
						<div className={`${mainClass}__light-rays__ray-3`}></div>
						<div className={`${mainClass}__light-rays__ray-4`}></div>
						<div className={`${mainClass}__light-rays__ray-5`}></div>
					</div>
					<div className={`${mainClass}__light-rays mirrored`}>
						<div className={`${mainClass}__light-rays__ray-0`}></div>
						<div className={`${mainClass}__light-rays__ray-1`}></div>
						<div className={`${mainClass}__light-rays__ray-2`}></div>
						<div className={`${mainClass}__light-rays__ray-3`}></div>
						<div className={`${mainClass}__light-rays__ray-4`}></div>
					</div>
				</Fragment>
			)}

			<div
				style={{ ...style, display: configBrands[brand].removeDefaultDecoration ? "block": "none" }}
				className={`${mainClass}__decoration-container`}
			>
				<img
					src={src}
					alt=""
					fetchpriority="high"
					decoding="async"
					className={`${mainClass}__decoration-container__img`}
				/>
			</div>
		</Fragment>
	);
};
export default Decoration;
